import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { ShieldX } from 'lucide-react';

/**
 * 403 Forbidden page shown when user lacks required permissions
 */
export function ForbiddenPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('errors');

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg px-4">
      <Card className="max-w-md w-full rounded-[14px] border-border-c shadow-card-lift p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="grid h-14 w-14 place-items-center rounded-xl bg-dot-danger-soft text-dot-danger-fg border border-border-c">
            <ShieldX className="h-7 w-7" aria-hidden="true" />
          </div>
        </div>

        <h1 className="font-display text-[22px] font-bold tracking-[-0.02em] text-ink mb-3">
          {t('forbidden_page.title')}
        </h1>

        <p className="mb-7 text-[13px] text-muted-foreground">
          {t('forbidden_page.description')}
        </p>

        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          <Button onClick={() => navigate('/dashboard')} variant="default" size="sm" className="h-9">
            {t('forbidden_page.go_to_dashboard')}
          </Button>
          <Button onClick={() => navigate(-1)} variant="outline" size="sm" className="h-9">
            {t('forbidden_page.go_back')}
          </Button>
        </div>

        <div className="mt-6 pt-5 border-t border-border-c">
          <p className="text-[12.5px] text-muted-foreground">
            {t('forbidden_page.need_help')}{' '}
            <a href="mailto:admin@example.com" className="text-accent-c hover:underline">
              {t('forbidden_page.contact_admin')}
            </a>
          </p>
        </div>
      </Card>
    </div>
  );
}
